import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const subscribeNewsletter = (data) =>
  api.post("/newsletter", data).then((r) => r.data);

export const sendContact = (data) => api.post("/contact", data).then((r) => r.data);
